module.exports = __webpack_public_path__ + "img/second-onboarding.acf657d8.png";